import React, { useEffect, useState } from "react";
import "./Order.css";
import { Button, Card, Col, Container, Nav, Navbar, Row, Dropdown, Table } from "react-bootstrap";
// import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
// import { IoIosArrowForward } from "react-icons/io";
import Account from "../src/Photos/Account.png";
import Logo from "../src/Photos/eximtracfinallogo.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import container from "../src/Photos/Container.png";
import * as XLSX from "xlsx";

function Order() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    const { userId, orderId } = useParams(); // Get userId and orderId from the URL

    const [orderDetails, setOrderDetails] = useState([]);
    // const [fileData, setFileData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrderDetails = async () => {
            const token = localStorage.getItem("token");

            if (!orderId || !token) {
                const errorMsg = "Missing required data: orderId or token.";
                setError(errorMsg);
                console.error(errorMsg);
                return;
            }

            try {
                const response = await fetch(
                    `https://api-ft5g.onrender.com/Get-Order-data-user-and-admin/${userId}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    console.log("Order Details Response:", data); // Debugging response
                    const filteredOrder = data.data?.filter((item) => item.OrderID === orderId);
                    setOrderDetails(filteredOrder || []);
                } else {
                    const errorMsg = `Failed to fetch order details: ${response.status} ${response.statusText}`;
                    throw new Error(errorMsg);
                }
            } catch (err) {
                console.error("Error fetching order details:", err);
                setError(err.message);
            }
        };

        fetchOrderDetails();
    }, [userId, orderId]); // Add userId and orderId as dependencies


    const [fileData2, setFileData2] = useState([]);
    const [error1, setError1] = useState(null);

    useEffect(() => {
        const fetchFileData = async () => {
            const token = localStorage.getItem("token");

            if (!userId || !token) {
                const errorMsg = "Missing required data: userId or token.";
                console.error(errorMsg);
                return;
            }

            try {
                const response = await fetch(
                    `https://api-ft5g.onrender.com/get-files-data/${userId}/${orderId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    console.log("File Data Response:", data);
                    setFileData2(data.files || []);
                } else {
                    throw new Error(`Failed to fetch file data: ${response.status}`);
                }
            } catch (err) {
                console.error("Error fetching file data:", err);
                setFileData2([]); // Treat as no data
            }
        };

        fetchFileData();
    }, [userId, orderId]);


    const [shipmentData, setShipmentData] = useState([]);
    const [error2, setError2] = useState(null);

    useEffect(() => {
        if (!userId || !orderId) return;

        const fetchShipmentData = async () => {
            const token = localStorage.getItem("token");
            try {
                const response = await fetch(
                    `https://api-ft5g.onrender.com/get-shipment-details/${userId}/${orderId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const payload = await response.json();

                if (response.ok && payload.success && payload.shipment) {
                    setShipmentData([payload.shipment]);
                } else {
                    setShipmentData([]); // No data case
                }
            } catch (err) {
                console.error("Error fetching shipment data:", err);
                setShipmentData([]); // Treat fetch failure as no data (optional)
            }
        };

        fetchShipmentData();
    }, [userId, orderId]);

    const handleDownloadZip = async (userId, orderId) => {
        try {
            const response = await fetch(`https://api-ft5g.onrender.com/download-order-files-zip/${userId}/${orderId}`);

            if (!response.ok) {
                throw new Error('Failed to download zip');
            }

            const blob = await response.blob();

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Order_${orderId}_Files.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download ZIP failed", error);
        }
    };

    const handleDownloadFile = async (userId, orderId, fileName) => {
        try {
            const response = await fetch(`https://api-ft5g.onrender.com/download-single-file/${userId}/${orderId}/${encodeURIComponent(fileName)}`);

            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download individual file failed", error);
        }
    };

    const [message, setMessage] = useState("");
    const [messagetype, setMessageType] = useState("");


    const handleDownloadExcel = () => {
        if (orderDetails.length === 0) {
            setMessage("No data available to download.");
            setMessageType("danger");
            return;
        }

        // Define mapping between keys in userDetails and labels for Excel
        const columnMap = [
            { key: "OrderID", label: "Order ID" },
            { key: "UploadDate", label: "Ordered On" },
            { key: "SKU_CODE", label: "SKU Code" },
            { key: "PRODUCT_DESCRIPTION", label: "Product Description" },
            { key: "WEIGHT_PER_PKT_GRAMS", label: "Weight Per Packet (gm)" },
            { key: "UNIT_PER_CTN", label: "Quantity" },
            { key: "CartonQty", label: "No. of Cases" },
            { key: "TotalQty", label: "Total QTY" },
            { key: "RatePerUnitUSD", label: "Rate Per Unit USD" },
            { key: "RatePerCaseUSD", label: "Rate Per Case USD" },
            { key: "TotalRateInUSDFobIndia", label: "Total Rate In USD FOB INDIA" },
            { key: "TotalNetWeight", label: "Total Net Weight" },
        ];

        // Format data to match key order
        const formattedData = orderDetails.map(item => {
            const reordered = {};
            columnMap.forEach(({ key, label }) => {
                reordered[label] = item[key] ?? "";
            });
            return reordered;
        });

        // Extract just the column labels for headers
        const headers = columnMap.map(col => col.label);

        // Create Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EnquiryDetails");

        XLSX.writeFile(workbook, `Enquiry_Details_${new Date().toISOString()}.xlsx`);
    };


    const [isLoggedIn, setIsLoggedIn] = useState(false);
    //   const navigate = useNavigate();

    useEffect(() => {
        // Check if the user is logged in when the component mounts
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        setIsLoggedIn(!!(token && userId)); // Set `isLoggedIn` based on the existence of token and userId
    }, []);

    const handleLoginClick = () => {
        if (isLoggedIn) {
            alert("You are already logged in!"); // Show an alert if already logged in
        } else {
            navigate("/Login"); // Redirect to login page if not logged in
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        console.log("User logged out and data removed from localStorage.");
        setIsLoggedIn(false);
        navigate("/Login"); // Redirect to login
    };


    const totals = orderDetails.reduce(
        (acc, item) => {
            acc.cases += parseFloat(item.CartonQty) || 0;
            acc.totalQty += parseFloat(item.TotalQty) || 0;
            acc.totalRate += parseFloat(item.TotalRateInUSDFobIndia) || 0;
            acc.totalWeight += parseFloat(item.TotalNetWeight) || 0;
            return acc;
        },
        { cases: 0, totalQty: 0, totalRate: 0, totalWeight: 0 }
    );

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <p className="mt-3 logosidetext">Government Recognised Export House</p>
                        </Nav>

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/" className="navtext">Home</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/Aboutus" className="navtext">About Us</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/Products" className="navtext">Shop Now</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/ContactUs" className="navtext">Contact Us</Nav.Link>
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-3">
                                <Nav.Link as={Link} to="/ProductCatalogue" className="navtext">Product Catalogue</Nav.Link>
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle
                                    className="scrollbtn2 p-0 mx-3 mt-1 responsiveview"
                                    id="dropdown-basic"
                                >
                                    <img
                                        src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleLoginClick}>Login</Dropdown.Item> {/* Login click handler */}
                                    {isLoggedIn && <Dropdown.Item href="/Profile">My Profile</Dropdown.Item>}
                                    {isLoggedIn && <Dropdown.Item href="/UserDashboard">Dashboard</Dropdown.Item>}
                                    {isLoggedIn && (
                                        <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0 mx-3 responsiveview">
                                <Link to="/Profile">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Link>
                            </Button> */}

                            <Button onClick={scrollToTop} className="scrollbtn2 p-0 mx-3 responsiveview">
                                <Link to="/Addtocontainer">
                                    <img src={container}
                                        alt="container"
                                        className="d-inline-block align-top"
                                    />
                                </Link>
                            </Button>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle
                            className="scrollbtn2 p-0 me-3 mobileview"
                            id="dropdown-basic"
                        >
                            <img
                                src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleLoginClick}>Login</Dropdown.Item> {/* Login click handler */}
                            {isLoggedIn && <Dropdown.Item href="/Profile">My Profile</Dropdown.Item>}
                            {isLoggedIn && <Dropdown.Item href="/UserDashboard">Dashboard</Dropdown.Item>}
                            {isLoggedIn && (
                                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button onClick={scrollToTop} className="scrollbtn2 p-0 mobileview">
                        <Link to="/Addtocontainer">
                            <img src={container}
                                alt="container"
                                className="d-inline-block align-top"
                            />
                        </Link>
                    </Button>
                </Container>
            </Navbar>

            {/* -----------------Navbar Complete---------------- */}

            <Container fluid className="mt-3">
                <Row>
                    <Col className="mb-3 mt-3" lg={12} xs={12}>
                        <Card className="p-4">
                            <h4 className="text-center">SHIPMENT DETAILS</h4>
                            {error2 && <p className="text-danger">Error: {error2}</p>}
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Order ID</th>
                                        <th>Order Status</th>
                                        <th>Proforma Invoice Number</th>
                                        <th>Proforma Invoice Date</th>
                                        <th>Commercial Invoice Number</th>
                                        <th>Commercial Invoice Date</th>
                                        <th>Container Number</th>
                                        <th>Shipping Lines</th>
                                        <th>BL Number</th>
                                        <th>ETA</th>
                                        <th>ETD</th>
                                        <th>Discharge Port</th>
                                        <th>Final Destination</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fileData2.length === 0 ? (
                                        <p>No Shipment Data Available.</p>
                                    ) : (
                                        shipmentData.map((shipment, index) => (
                                            <tr key={index}>
                                                <td>{shipment.OrderID}</td>
                                                <td>{shipment.ShippingStatus}</td>
                                                <td>{shipment.ProformaInvoiceNumber}</td>
                                                <td>{shipment.ProformaInvoiceDate}</td>
                                                <td>{shipment.CommercialInvoiceNumber}</td>
                                                <td>{shipment.CommercialInvoiceDate}</td>
                                                <td>{shipment.ContainerNumber}</td>
                                                <td>{shipment.ShippingLines}</td>
                                                <td>{shipment.BLNumber}</td>
                                                <td>{shipment.ETA}</td>
                                                <td>{shipment.ETD}</td>
                                                <td>{shipment.DischargePort}</td>
                                                <td>{shipment.FinalDestination}</td>
                                            </tr>
                                        )
                                        ))}
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12} xs={12} className="mt-3">
                        <Card className="p-4">
                            <h5 className="text-center mb-4">SHIPMENT FILES</h5>

                            {error1 && <p className="text-danger">Error: {error1}</p>}
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Order ID</th>
                                        {/* <th>User ID</th> */}
                                        <th>Document Type</th>
                                        <th>File Name</th>
                                        {/* <th>File Type</th> */}
                                        <th>Upload Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {shipmentData.length === 0 ? (
                                        <p>No Shipment Files Available.</p>
                                    ) : (
                                        fileData2.map((file, index) => (
                                            <tr key={index}>
                                                <td>{file.OrderID}</td>
                                                {/* <td>{file.UserID}</td> */}
                                                <td>{file.DocumentType}</td>
                                                <td>{file.FileName}</td>
                                                {/* <td>{file.FileType}</td> */}
                                                <td>{new Date(file.UploadDate).toLocaleDateString()}</td>
                                                <td>
                                                    <Button
                                                        variant="primary" className="mt-2"
                                                        onClick={() => handleDownloadZip(file.UserID, file.OrderID)}
                                                    >
                                                        Download ZIP
                                                    </Button>

                                                    <Button
                                                        variant="success" className="mt-2"
                                                        onClick={() => handleDownloadFile(file.UserID, file.OrderID, file.FileName)}
                                                    >
                                                        Download File
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                        ))}
                                </tbody>
                            </Table>

                            {/* <hr className="my-4" />

                            <p className="text-center text-muted orderfont">
                                Your order will be delivered tentatively by <span style={{ fontWeight: "bold" }}>15 Dec 2024</span>
                            </p> */}
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col className="mt-3">
                        <Card className="p-4">
                            <Row>
                                <Col className="">
                                    <h4 className="mb-4">ORDER DETAILS</h4>
                                </Col>

                                <Col className="text-end">
                                    <Button className="mb-4" onClick={handleDownloadExcel}>
                                        Download as Excel
                                    </Button>
                                </Col>
                            </Row>

                            {orderDetails.length > 0 ? (
                                <Table responsive bordered hover>
                                    <thead>
                                        <tr className="text-center">
                                            <th>Order ID</th>
                                            <th>Ordered On</th>
                                            <th>SKU Code</th>
                                            <th>Brand</th>
                                            <th>Product Description</th>
                                            {/* <th>Weight Per Packet (gm)</th> */}
                                            <th>Unit Size</th>
                                            <th>Unit Measurement Type</th>
                                            <th>Unit Per Case</th>
                                            <th>No. of Cases</th>
                                            <th>Total QTY</th>
                                            <th>Rate Per Unit USD</th>
                                            <th>Rate Per Case USD</th>
                                            <th>Total Rate In USD FOB INDIA</th>
                                            <th>Total Net Weight</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderDetails.map((item, index) => (
                                            <tr key={index} className="text-center">
                                                <td>{item.OrderID}</td>
                                                <td>{new Date(item.UploadDate).toLocaleDateString()}</td>
                                                <td>{item.SKU_CODE}</td>
                                                <td>{item.BRAND}</td>
                                                <td>{item.PRODUCT_DESCRIPTION}</td>
                                                {/* <td>{item.WEIGHT_PER_PKT_GRAMS}</td> */}
                                                <td>{item.UNIT_MEASUREMENT}</td>
                                                <td>{item.UNIT_MEASUREMENT_TYPE}</td>
                                                <td>{item.UNIT_PER_CTN} {item.UNIT}</td>
                                                <td>{item.CartonQty}</td>
                                                <td>{item.TotalQty}</td>
                                                <td>{Number(item.RatePerUnitUSD).toFixed(2)}</td>
                                                <td>{Number(item.RatePerCaseUSD).toFixed(2)}</td>
                                                <td>{Number(item.TotalRateInUSDFobIndia).toFixed(2)}</td>
                                                <td>{Number(item.TotalNetWeight).toFixed(2)}</td>
                                            </tr>
                                        ))}

                                        <tr className="text-center">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>TOTAL:</td>
                                            <td>{totals.cases}</td>
                                            <td>{totals.totalQty}</td>
                                            <td></td>
                                            <td></td>
                                            <td>{totals.totalRate.toFixed(2)}</td>
                                            <td>{totals.totalWeight.toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-center text-muted">No details available for this order.</p>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

export default Order;